import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'    
import {useSelector, useDispatch} from 'react-redux'      
import {getEntries, reset} from '../features/entries/entrySlice'
import Spinner from '../components/Spinner'
import EntryItem from '../components/EntryItem' 

function Homepage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {user} = useSelector((state) => state.auth) 
  const {entries, isError, message, isLoading} = useSelector((state) => state.entries)  
  // where can I access state.entries? 
  
  useEffect(() => {
    if (isError) {
      console.log(message)
    }

    if (!user) {
      navigate('/login')    
    }

    dispatch(getEntries())

    return () => {
      dispatch(reset())
    }
   
  //}, [navigate, dispatch, user, entrys, isError, message, ])
}, [navigate, dispatch, user])

  if (isLoading) {
    return <Spinner/>     
  }

  return (
    <>
      <section>
        {/* we have access to the user, as defined above ^^
        This syntax means: if user, show user.name. Pretty neat. */}

        {/* <h1>Welcome {user && user.name}</h1>     */}
        <h1>Welcome to Roman's County Jail</h1>
        <p className="logga">Current Inmates:</p>
      </section>

      {/* created with section.content */}
      <section className="content">
        {entries.length > 0 ? (     
          
          // <div className="entries">
          //   {entries.map((entry) => (
          //     <EntryItem key={entry.user} entry={entry} />
          //   ))}
          // </div>
          
          <div className="entries">
            {entries.map((entry) => (
              <EntryItem key={entry.user} key2={user._id} entry={entry} user={user}/>
            ))}
          </div>

          // <div className="entries">
          //   {entries.map((entry) => (
          //     <EntryItem key={[entry._id, user._id]} entry={entry} user={user}/>
          //   ))}
          // </div>
        ) : (
          <h3>Roman's County Jail has no current inmates (yet)</h3>
        )}
      </section>
    </>
  )
}

export default Homepage